/* THE CROWN ROOM — theme behaviour (Shopify AJAX Cart API) */
(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ---------------- Drawers ---------------- */
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const focusable = drawer.querySelector('input, button, a');
    if (focusable) setTimeout(() => focusable.focus(), 120);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.style.overflow = '';
  }
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      if (opener.getAttribute('data-drawer-open') === 'cart-drawer') refreshCart();
      return;
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------------- Cart ---------------- */
  const cartCountEls = () => $$('[data-cart-count]');

  function setBusy(state) {
    document.documentElement.classList.toggle('cart-busy', state);
  }

  async function refreshCart() {
    const drawerBody = $('[data-cart-drawer-content]');
    if (!drawerBody) return;
    try {
      const res = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer-content`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-content]');
      if (fresh) drawerBody.innerHTML = fresh.innerHTML;
      const count = doc.querySelector('[data-cart-item-count]');
      if (count) updateCount(parseInt(count.textContent, 10) || 0);
    } catch (e) {
      /* keep existing markup on failure */
    }
  }

  function updateCount(count) {
    cartCountEls().forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function addToCart(id, quantity) {
    setBusy(true);
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }),
      });
      if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        window.alert(error.description || 'This item could not be added to your cart.');
        return false;
      }
      await refreshCart();
      openDrawer('cart-drawer');
      return true;
    } finally {
      setBusy(false);
    }
  }

  async function changeLine(line, quantity) {
    setBusy(true);
    try {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else {
        await refreshCart();
      }
    } finally {
      setBusy(false);
    }
  }

  document.addEventListener('click', (event) => {
    const quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      addToCart(quickAdd.getAttribute('data-quick-add'), 1);
      return;
    }
    const lineChange = event.target.closest('[data-line-change]');
    if (lineChange) {
      event.preventDefault();
      changeLine(lineChange.getAttribute('data-line'), lineChange.getAttribute('data-line-change'));
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const id = form.querySelector('[name="id"]').value;
    const qtyInput = form.querySelector('[name="quantity"]');
    addToCart(id, qtyInput ? qtyInput.value : 1);
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Product variants ---------------- */
  function initProduct(root) {
    const dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const priceEl = $('[data-product-price]', root);
    const submit = form ? form.querySelector('[data-add-button]') : null;

    function selectedOptions() {
      return $$('[data-option-index]', root).map((group) => {
        const active = group.querySelector('[aria-pressed="true"]');
        return active ? active.getAttribute('data-value') : null;
      });
    }

    function update() {
      const chosen = selectedOptions();
      const variant = variants.find((v) => v.options.every((value, i) => chosen[i] == null || value === chosen[i]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.getAttribute('data-add-label') : submit.getAttribute('data-sold-label');
      }
      const media = $(`[data-media-id="${variant.featured_media_id}"]`, root);
      if (media) media.click();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    $$('[data-option-index] [data-value]', root).forEach((button) => {
      button.addEventListener('click', () => {
        $$('[data-value]', button.closest('[data-option-index]')).forEach((sibling) => sibling.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    $$('[data-media-id]', root).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = $('[data-main-image]', root);
        if (main) {
          main.src = thumb.getAttribute('data-full');
          main.alt = thumb.getAttribute('data-alt') || main.alt;
        }
        $$('[data-media-id]', root).forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------------- Collection sorting / filtering ---------------- */
  function initToolbar() {
    $$('[data-auto-submit]').forEach((el) => el.addEventListener('change', () => el.closest('form').submit()));
  }

  function init() {
    $$('[data-product-root]').forEach(initProduct);
    initToolbar();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
